import React, { useContext, useState, useEffect } from 'react'
import { useTranslation } from 'i18n'
import { Field, Formik, ErrorMessage } from 'formik'
import { scrollToTopOfCurrentStep } from 'services/break'
import LegacyRetinaImage from 'components/LegacyRetinaImage'
import { userContext } from 'global/context/sub-contexts/userContext'
import { submit as leadGenSubmit, checkSubmissionLimit } from 'services/leadgen'
import analytics from 'global/AnalyticsData'
import trackMessage from 'util/track-message'
import {
  getFieldByType,
  generateFormValidation2,
  generateInitialValues,
  POSTPayloadContructor,
} from './LeadGenHelpers'
import './LeadGen3.scss'

import { AddressModal } from 'components/forms'

import { Modal, Checkbox } from '@mui/material'
import { addressLookup, addressValidate } from 'services/address'
import { generateTokenService, validateTokenService } from 'services/token'
import { isObjectKeysNotEmpty } from 'util/objectNotEmpty'
import ConfirmationModal from 'components/forms/confirmation-modal/ConfirmationModal'
import { useTurnstile } from '../../hooks/useTurnstile'
import { Turnstile } from '@marsidev/react-turnstile'
import { getTurnstileSiteKey } from 'util/getTurnstileSiteKey'
const LeadGenStep = ({
  brk,
  breakId,
  step,
  terms,
  onEngage = function () {},
  onAwardPoints = function () {},
  onChangeBackground = function () {},
  nextStepButton,
  skipButton,
  stepId,
  handleInstantWinEvent = null,
}) => {
  const { t } = useTranslation(['leadGen', 'common'])
  const [showEmailConfirmationModal, setShowEmailConfirmationModal] =
    useState(false)
  const [addressSuggestionModal, setAddressSuggestionModal] = useState(false)
  const [suggestedAddress, setSuggestionAddress] = useState({})
  const [invalidAddress, setInvalidAddress] = useState(false)
  const [submissionLimitReached, setSubmissionLimitReached] =
    useState('not-checked')
  //Form status of validation/submission used as class to style things like the submit button

  //just a dumb bool to see whether we should show the thank you or not.
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [apiError, setApiError] = useState(null)
  // Submitting twice sent two verification emails, and the second token
  // invalidates the first, so the code the user already opened stops working
  // (BR-3543). Same guard the receipt views use.
  const [doubleClickTimeoutActive, setDoubleClickTimeoutActive] =
    useState(false)
  let stepFormConfig = step.leadGenForm
  const userProfile = useContext(userContext).getProfile()
  let initialValues = generateInitialValues(userProfile, step)
  initialValues['permalink'] = brk.permalink
  initialValues['turnstileToken'] = ''
  initialValues['turnstileTokenType'] = ''
  const dynamicValidationSchema = generateFormValidation2(stepFormConfig)

  const { turnstileRef, getTurnstileToken } = useTurnstile()

  stepFormConfig.requireRecaptcha = true
  if ((brk.permalink === 'unilever-fc-gotham') || (brk.permalink === 'loreal-la-roche-posay-walmart-event')) {
    stepFormConfig.requireRecaptcha = false
  }

  useEffect(() => {
    const makeDumbBoolean = str => {
      if (str === 'true') {
        return true
      } else if (str === 'false') {
        return false
      } else {
        return str
      }
    }

    if (submissionLimitReached === 'not-checked') {
      console.log('checking submission limit')
      if (step.leadGenForm.hasSubmissionLimit === true) {
        checkSubmissionLimit(breakId, stepId, step.leadGenForm.id)
          .then(res => {
            res.text().then(res => {
              let bool = makeDumbBoolean(res)
              setSubmissionLimitReached(bool)
            })
          })
          .catch(err => {
            console.warn(`BR-9335122: submissionLimitReached`)
            console.error(err)
            setSubmissionLimitReached(false)
          })
      } else {
        setSubmissionLimitReached(false)
      }
    }
  }, [brk, stepId, submissionLimitReached])

  const handleAddressSuggestionModal = () => {
    setAddressSuggestionModal(!addressSuggestionModal)
  }

  const validateAddress = async values => {
    // Skip address validation if hasAddressValidation is false
    if (!step.leadGenForm?.hasAddressValidation) {
      return true
    }

    setInvalidAddress(false)
    let addressValues = {
      address1: values.address,
      // address2: values.address2 || '',
      city: values.city,
      state: values.state,
      zip: values.zipCode,
      //   zip2: '',
    }

    const isAddressNotEmpty = isObjectKeysNotEmpty(addressValues)

    if (isAddressNotEmpty) {
      await addressValidate(addressValues)
        .then(res => {
          const { openSuggestionModal, suggestionAddress } = res
          if (openSuggestionModal) {
            setSuggestionAddress(suggestionAddress)
            setAddressSuggestionModal(!addressSuggestionModal)
            return false
          } else {
            return true
          }
        })
        .catch(err => {
          console.warn(`BR-9335144`)
          setInvalidAddress(true)
          setAddressSuggestionModal(false)
        })
    }
    return true
  }

  const lookupAddress = async values => {
    // Skip address lookup if hasAddressValidation is false
    if (!step.leadGenForm?.hasAddressValidation) {
      return
    }

    setInvalidAddress(false)
    let addressValues = {
      address1: values.address || '',
      address2: values.address2 || '',
      city: values.city,
      state: values.state,
      zip: values.zipCode,
      zip2: '',
    }

    const isAddressNotEmpty = isObjectKeysNotEmpty({
      address1: values.address,
      city: values.city,
      state: values.state,
      zip: values.zipCode,
    })
    if (isAddressNotEmpty) {
      await addressLookup(addressValues)
        .then(res => {
          const addressSuggestion = res.detail
          setSuggestionAddress(addressSuggestion)
        })
        .then(data => {
          setAddressSuggestionModal(!addressSuggestionModal)
        })
        .catch(err => {
          console.warn(`BR-9335133: addressLookup`)
          console.warn(err)
        })
    }
  }

  const onSendToken = async ({
    tokenSource,
    email,
    firstName,
    lastName,
    tokenSourceId,
    permalink,
  }) => {
    await generateTokenService({
      tokenSourceId: tokenSourceId || '',
      tokenSource: tokenSource || '',
      permalink,
      email,
      firstName,
      lastName,
    })
  }

  const handleLeadGenSubmit = async (values, actions) => {
    if (doubleClickTimeoutActive) return

    setDoubleClickTimeoutActive(true)
    setTimeout(() => setDoubleClickTimeoutActive(false), 2000)

    setApiError(null)
    try {
      if (values.zipCode) {
        const isAddressValid = await validateAddress(values)
        if (!isAddressValid) {
          return
        }
      }

      if (stepFormConfig.hasEmailVerification) {
        const { firstName, lastName, email } = values

        try {
          await onSendToken({
            tokenSource: step.type,
            email,
            firstName,
            lastName,
            stepId,
            breakPermalink: brk.permalink,
          })
          setShowEmailConfirmationModal(true)
        } catch {
          trackMessage(
            `Leadgen form submission: FAILURE. Reason: INVALID_EMAIL. permalink: ${
              window && window?.location?.href
                ? window?.location?.href
                : 'unknown'
            } response status: ${
              response.status
            }. Response Body: ${JSON.stringify(responseBody, null, 2)}. User: ${
              userProfile?.email
            }`,
          )
          console.warn(`BR-9335145: handleLeadGenSubmit`)
          setApiError(t('leadGen:error.invalidEmail'))
        }
        return
      }

      await submitLeadGenForm(values, actions)
    } catch (e) {
      // keep on moving if there's an API issue
      console.warn(`BR-9335148: handleLeadGenSubmit`)
      console.warn(e)
    }
  }

  const submitLeadGenForm = async values => {
    let updatedValues = { ...values }

    if (stepFormConfig.requireRecaptcha === true) {
      const token = turnstileRef.current?.getResponse()
      updatedValues.turnstileTokenType = 'visible'
      updatedValues.turnstileToken = token
    }

    const response = await leadGenSubmit(
      stepFormConfig.id,
      breakId,
      step.id,
      updatedValues,
    )

    //Form submission successful, as API returned 200
    if (response.status === 200) {
      onEngage && onEngage()
      onAwardPoints && onAwardPoints()

      analytics.stepEvent('step_interaction_lead_gen_info_submission', step, {})

      //setFormStatus('submitted')
      setFormSubmitted(true)
      scrollToTopOfCurrentStep(step.id)

      const result = await response.json()
      //console.log(`result`, result)

      // give the page a sec to scroll up
      setTimeout(() => {
        handleInstantWinEvent &&
          handleInstantWinEvent({
            eventName: `leadgen_submit`.toLowerCase(),
            context: { form: result, stepId: step.id },
          })
      }, 400)

      //push submission to analytics
      if (typeof window !== `undefined`) {
        step.leadGenForm.confirmations &&
          step.leadGenForm.confirmations.map(
            (confirmation, index) =>
              (values.confirmations[index] = confirmation),
          )
      }
    } else {
      const responseBody = await response.json()
      trackMessage(
        `Leadgen form submission: FAILURE. Reason: UNCAUGHT_ERROR. permalink: ${
          window && window?.location?.href ? window?.location?.href : 'unknown'
        } response status: ${response.status}. Response Body: ${JSON.stringify(
          responseBody,
          null,
          2,
        )}. User: ${userProfile?.email}`,
      )
      setApiError(responseBody.message)
    }
  }

  const handleEmailConfirmation = ({ values, confirmed }) => {
    setShowEmailConfirmationModal(false)
    if (confirmed) {
      const payloadValues = POSTPayloadContructor(stepFormConfig, values)
      submitLeadGenForm(payloadValues)
    }
  }

  return (
    <section className={`leadgen-step-3 leadgen-step`}>
      <div
        className={`step-content ${step.backgroundImage ? ' with-shadow' : ''}`}
      >
        {submissionLimitReached === true && (
          <div className="leadgen-form-body-container submission-reached">
            <div className="intro">
              {step.leadGenForm.submissionLimitReachedHeadline && (
                <h1
                  className={`step-content__title`}
                  dangerouslySetInnerHTML={{
                    __html: step.leadGenForm.submissionLimitReachedHeadline,
                  }}
                />
              )}

              {step.leadGenForm.submissionLimitReachedCopy && (
                <h3
                  dangerouslySetInnerHTML={{
                    __html: step.leadGenForm.submissionLimitReachedCopy,
                  }}
                />
              )}
            </div>
          </div>
        )}
        {submissionLimitReached === false && (
          <>
            {formSubmitted === false && (
              <div className="leadgen-form-body-container">
                <div className="intro">
                  {stepFormConfig.headline && (
                    <h1
                      className={`step-content__title leadgen-form-title`}
                      dangerouslySetInnerHTML={{
                        __html: stepFormConfig.headline,
                      }}
                    />
                  )}
                  {step.introCopy && (
                    <h2
                      className={`leadgen-form-subhead step-subcopy`}
                      dangerouslySetInnerHTML={{ __html: step.introCopy }}
                    />
                  )}
                  {stepFormConfig.bodyCopy && (
                    <p
                      className={`step-subcopy leadgen-form-subhead`}
                      dangerouslySetInnerHTML={{
                        __html: stepFormConfig.bodyCopy,
                      }}
                    />
                  )}
                  {step.headerImage && (
                    <LegacyRetinaImage
                      image={step.headerImage}
                      className={`leadgen-form-image`}
                    />
                  )}
                </div>
                <Formik
                  initialValues={initialValues}
                  validationSchema={dynamicValidationSchema}
                  validateOnBlur={false}
                  validateOnChange={true}
                  validateOnMount={true}
                  onSubmit={async (values, actions) => {
                    console.log('Leadgen form submitted!')
                    values = POSTPayloadContructor(stepFormConfig, values)
                    await handleLeadGenSubmit(values, actions)
                  }}
                >
                  {formik => {
                    const handleAddressSuggestionModalAccepted =
                      suggestedAddress => {
                        setAddressSuggestionModal(false)
                        let vals = {
                          ...formik.values,
                          address:
                            suggestedAddress.address1 ??
                            formik.values.address1 ??
                            '',
                          address2:
                            suggestedAddress.address2 ??
                            formik.values.address2 ??
                            '',
                          city:
                            suggestedAddress.city ?? formik.values.city ?? '',
                          state:
                            suggestedAddress.state ?? formik.values.state ?? '',
                          zipCode:
                            suggestedAddress.zip ??
                            formik.values.postalCode ??
                            '',
                        }
                        Object.keys(vals).forEach(key => {
                          if (vals[key] === 'null') {
                            vals[key] = ''
                          }
                        })
                        formik.setValues(vals)
                      }

                    return (
                      <>
                        <Modal
                          open={addressSuggestionModal}
                          onClose={handleAddressSuggestionModal}
                        >
                          <AddressModal
                            notValid={invalidAddress}
                            values={formik.values}
                            onClose={handleAddressSuggestionModal}
                            onAccept={handleAddressSuggestionModalAccepted}
                            suggestedAddress={suggestedAddress}
                          />
                        </Modal>
                        <Modal
                          open={showEmailConfirmationModal}
                          onClose={() => setShowEmailConfirmationModal(false)}
                        >
                          <ConfirmationModal
                            breakPermalink={brk.permalink}
                            stepType={step.type}
                            stepId={stepId}
                            values={formik.values}
                            validateTokenService={validateTokenService}
                            onConfirm={handleEmailConfirmation}
                            onSendToken={onSendToken}
                          />
                        </Modal>
                        <form>
                          <div className="fields">
                            {stepFormConfig.fields &&
                              stepFormConfig.fields.map((item, i) => {
                                return getFieldByType({
                                  field: item,
                                  formik,
                                  index: i,
                                  lookupAddress,
                                })
                              })}
                          </div>
                          <div className="confirmations">
                            {step.leadGenForm.confirmations &&
                              step.leadGenForm.confirmations.map((item, i) => {
                                return (
                                  <Field name={item.id} key={i}>
                                    {({ field, meta }) => {
                                      return (
                                        <>
                                          <div
                                            className={`leadgen-confirmation `}
                                            key={i}
                                          >
                                            <Field
                                              type="checkbox"
                                              // defaultChecked={item.precheck}
                                              value={formik.values[item.id]}
                                              component={Checkbox}
                                              id={field.name}
                                              name={field.name}
                                              error={formik.errors[item.id]}
                                              touched={
                                                formik.touched[item.id] && true
                                                  ? 'true'
                                                  : ''
                                              }
                                              onChange={e => {
                                                console.log(
                                                  `checked`,
                                                  e.target.checked,
                                                )
                                                formik.setFieldValue(
                                                  field.name,
                                                  e.target.checked,
                                                )
                                              }}
                                            />
                                            <label
                                              htmlFor={field.name}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  item.name ===
                                                  'legal-user-acknowledgement-confirmation'
                                                    ? '*By clicking Submit I acknowledge that I have read and agree to be bound by the Breaktime Media MWH, LLC'
                                                    : `${item.text}`,
                                              }}
                                            />
                                          </div>
                                          {meta.error && (
                                            <span className="error">
                                              <ErrorMessage name={field.name} />
                                              <br />
                                              <br />
                                            </span>
                                          )}
                                        </>
                                      )
                                    }}
                                  </Field>
                                )
                              })}
                            {apiError && (
                              <div
                                style={{ fontSize: '16px' }}
                                className="error"
                              >
                                {apiError}
                              </div>
                            )}
                          </div>
                          <Turnstile
                            ref={turnstileRef}
                            options={{ refreshExpired: 'manual' }}
                            siteKey={getTurnstileSiteKey()}
                            onExpire={() => turnstileRef.current?.reset()}
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          />
                          <button
                            type="submit"
                            className={`submit-button-${
                              formik.dirty === false ||
                              Object.keys(formik.errors).length > 0
                                ? 'form-valid'
                                : 'form-invalid'
                            }`}
                            disabled={doubleClickTimeoutActive}
                            onClick={e => {
                              e.preventDefault()
                              formik.handleSubmit()
                            }}
                          >
                            {t('common:submit')}
                          </button>
                          {terms && (
                            <span
                              class="terms"
                              dangerouslySetInnerHTML={{ __html: `*${terms}` }}
                            ></span>
                          )}
                        </form>
                      </>
                    )
                  }}
                </Formik>
              </div>
            )}
            {formSubmitted === true && (
              <div className={`leadgen-form-thank-you-container thank-you`}>
                {stepFormConfig.thanksHeadline && (
                  <h1
                    dangerouslySetInnerHTML={{
                      __html: stepFormConfig.thanksHeadline,
                    }}
                  />
                )}

                {stepFormConfig.thanksDesc && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: stepFormConfig.thanksDesc,
                    }}
                  />
                )}

                {stepFormConfig.thanksImage && (
                  <LegacyRetinaImage
                    image={stepFormConfig.thanksImage}
                    className={`leadgen-form-image`}
                  />
                )}
              </div>
            )}
          </>
        )}
        {skipButton}
        {nextStepButton}
      </div>
    </section>
  )
}

export default LeadGenStep
